import { motion } from 'framer-motion';
import styled, { css } from 'styled-components';

import theme from '../../../assets/theme';
import { parseSeconds } from '../../../utils/roundUtils';

export const LiveCountdown = ({
  secondsLeft,
  fontSize = '3vw',
  animate = false,
  isFrozen = false,
  fontColor = theme.colors.black,
}: {
  secondsLeft: number;
  fontSize?: string;
  fontColor?: string;
  isFrozen?: boolean;
  animate?: boolean;
}) => {
  if (animate) {
    return (
      <LiveCountdownAnimatedContainer
        key={secondsLeft}
        exit={{ scale: 0, display: 'none', opacity: 0 }}
        initial={{ scale: 0.3, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        $isFrozen={isFrozen}
        transition={{
          ease: 'easeInOut',
          duration: 0.6,
        }}
      >
        <span style={{ fontSize, color: fontColor }}>{parseSeconds(secondsLeft)}</span>
      </LiveCountdownAnimatedContainer>
    );
  }

  return (
    <LiveCountdownContainer $isFrozen={isFrozen}>
      <span style={{ fontSize, color: fontColor }}>{parseSeconds(secondsLeft)}</span>
    </LiveCountdownContainer>
  );
};

const LiveCountdownAnimatedContainer = styled(motion.div)<{
  $fontColor?: string;
  $fontSize?: string;
  $isFrozen?: boolean;
}>`
  width: 'fit-content';
  display: flex;
  justify-content: center;
  color: ${({ $fontColor }) => ($fontColor ? $fontColor : 'none')};
  font-size: ${({ $fontSize }) => ($fontSize ? $fontSize : '16px')};
  ${({ $isFrozen }) =>
    $isFrozen &&
    css`
      text-decoration: line-through;
    `}
`;

const LiveCountdownContainer = styled.div<{
  $fontColor?: string;
  $fontSize?: string;
  $isFrozen: boolean;
}>`
  color: ${({ $fontColor }) => ($fontColor ? $fontColor : 'none')};
  font-size: ${({ $fontSize }) => ($fontSize ? $fontSize : '16px')};
  display: flex;
  width: 'fit-content';
  justify-content: center;
  ${({ $isFrozen }) =>
    $isFrozen &&
    css`
      text-decoration: line-through;
    `}
`;
